export default function ($scope, $location, $window, $anchorScroll, AuthenticationService, FlashService, Restangular) {
    if(GetData().currentUser)
        $location.path('/account');

    $scope.menu = function() {
        $('html').toggleClass("nav-open");
    };

    $scope.$watch('email', function(){
        $scope.form.email.$setValidity('exists', true);
    });

    $scope.$root.$watch('current_language', function(new_value){
        $scope.updatePrescriptorType(new_value);
    });


    $scope.register = function () {
        $scope.dataLoading = true;

        AuthenticationService.PublicLogin(function(response){
            if(response.status == "200") {

                let userData = {
                    name : $scope.name,
                    email : $scope.email
                };

                Restangular
                    .all('user/request-promo')
                    .post(userData)
                    .then(data => {

                        FlashService.Success("PROMO_CREATED_CHECK_YOUR_EMAIL");

                        $scope.dataLoading = false;

                        //$location.path('/login');

                    }, error => {
                        $scope.dataLoading = false;

                        $anchorScroll("navbar");

                        let flash_error = "MALFORMET_DATA";

                        error.data.fields.forEach(function(field, index){
                            if(field.property_path == 'email'){
                                $scope.form[field.property_path].$setValidity('exists', false);
                            }
                        });
                        FlashService.Error(flash_error);

                        form.$invalid = false;

                    });
            }else{
                FlashService.Error("Internal Error")
            }
        }, true);

    };
};


/** WEBPACK FOOTER **
 ** ./js/theme/request-promo/controller.js
 **/